import clsx from 'clsx'
import { useContentEditorStyles } from 'components/WorkspaceEditor/styles/useContentEditorStyles'
import React, { memo, PropsWithChildren, ReactNode } from 'react'
import { ContentEditorProps } from './ContentEditor'

export interface ContentEditorLayoutProps
    extends Partial<PropsWithChildren<ContentEditorProps>> {
    children: ReactNode
}

/**
 * HOC to override the styles of the ContentEditor with CKEditor component
 */
export const ContentEditorLayout = memo<ContentEditorLayoutProps>(
    ({ children }) => {
        const overrides = useContentEditorStyles()

        return (
            <span className={clsx(Object.values(overrides))}>{children}</span>
        )
    }
)
